module.exports = __webpack_public_path__ + "media/images/area/index_hero_img_pc-7c7c54b03e299b54512314fd6509972b.jpg";